export class EmailServerConfig{
    constructor(obj) {
        if(!obj){
            return;
        }

        this.mailHost = obj.mailHost;
        this.mailPort = obj.mailPort;
        this.mailProtocole = obj.mailProtocole;
        this.mailStartTLS = !!obj.mailStartTLS;
        this.mailAuth = !!obj.mailAuth;
        this.mailUserName = obj.mailUserName;
        this.mailPassword = obj.mailPassword;
        this.mailSocketFactoryClass = obj.mailSocketFactoryClass;
        this.mailDebug = !!obj.mailDebug;
        this.mailFrom = obj.mailFrom;
        this.mailLabelFrom = obj.mailLabelFrom;
        this.mailCopyTo = obj.mailCopyTo;
        this.repondreA = obj.repondreA;
    }
}
